export default [
  [`Размер`, `XS`, `S`, `M`, `L`, `XL`, `2XL`],
  [`Российский размер`, `42`, `44`, `46`, `48`, `50`, `52`],
  [`Обхват бёдер, см`, `88`, `92`, `96`, `100`, `104`, `108`],
  [`Рост, см`, `164-170`, `164-170`, `164-170`, `164-170`, `164-170`, `164-170`]
];
